/* Build in libraries */

/* Third party libraries */
import { MapPinIcon } from '@heroicons/react/24/outline';
import { useQuery } from '@tanstack/react-query';
import ActiveProjectsWidget from '@/components/Rover/Widgets/ActiveProjectsWidget';
/* Components */
import ApprovedProjectsWidget from '@/components/Rover/Widgets/ApprovedProjectsWidget';
import BreakdownAcquisitionType from '@/components/Rover/Widgets/BreakdownAcquisitionTypeWidget';
import BreakdownConstructionType from '@/components/Rover/Widgets/BreakdownConstructionTypeWidget';
import BreakdownDealType from '@/components/Rover/Widgets/BreakdownDealTypeWidget';
import SocialDesignationWidget from '@/components/Rover/Widgets/SocialDesignationWidget';
import SummaryStatus from '@/components/Rover/Widgets/StatusSummaryWidget';
import TotalAcquisitionCostWidget from '@/components/Rover/Widgets/TotalAcquisitionCostWidget';
import TotalDevelopmentCostWidget from '@/components/Rover/Widgets/TotalDevelopmentCostWidget';
import TotalPreDevelopmentCostWidget from '@/components/Rover/Widgets/TotalPreDevelopmentCostWidget';
import TotalProposedSqFtWidget from '@/components/Rover/Widgets/TotalProposedSqFtWidget';
import TotalProposedUnitsWidget from '@/components/Rover/Widgets/TotalProposedUnitsWidget';
import { Card } from '@/components/shadcn/card.tsx';
import MapGoogle from '@/components/UI/GoogleMap/GoogleReactMap';
import LoadingCompanyDashboard from '@/components/UI/loading/LoadingCompanyDashboard';
/* Services */
import { getPartnerProposalsDashboard } from '../../../../api/Rover/partnerProposal';
import { RoverReactQueryKey } from '../../../../constants/ReactQueryKeys';
import PartnerProposalsNav from '../PartnerProposalNav';

const Dashboard = () => {
  //Tanstack: version 5 query implementation
  const fetchPartnerProposalsDashboard = useQuery({
    queryKey: [RoverReactQueryKey.GET_PARTNER_PROPOSALS_DASHBOARD],
    queryFn: () => getPartnerProposalsDashboard(),
  });

  const dashboardData = fetchPartnerProposalsDashboard?.data?.data;

  return (
    <>
      {fetchPartnerProposalsDashboard.isLoading && <LoadingCompanyDashboard />}
      {!fetchPartnerProposalsDashboard.isLoading && (
        <div className='max-w-screen-3xl mx-auto'>
          <PartnerProposalsNav />
          <section className='grid md:grid-cols-2 xl:grid-cols-4 gap-4'>
            <TotalDevelopmentCostWidget count={dashboardData?.totalDevelopmentCost || 0} />
            <TotalAcquisitionCostWidget count={dashboardData?.total_acquisition_cost || 0} />
            <TotalPreDevelopmentCostWidget count={dashboardData?.total_predevelopment_cost || 0} />
            <TotalProposedUnitsWidget count={dashboardData?.total_proposed_units || 0} />
          </section>
          <section className='my-4 grid md:grid-cols-3 xl:grid-cols-3 gap-4'>
            <ActiveProjectsWidget count={dashboardData?.active_projects || 0} />
            <ApprovedProjectsWidget count={dashboardData?.total_approved || 0} />
            <TotalProposedSqFtWidget count={dashboardData?.total_proposed_square_feet || 0} />
          </section>
          <div className='my-4'>
            {dashboardData?.application_status_summary && <SummaryStatus summary={dashboardData?.application_status_summary} />}
          </div>
          <div className='my-4'>
            <Card title='Project Location'>
              {!fetchPartnerProposalsDashboard.isLoading && dashboardData?.project_location?.length === 0 && (
                <div className='w-full flex justify-center items-center h-screen/2'>
                  <div className='flex justify-center items-center gap-2 text-primaryColor-normal'>
                    <MapPinIcon className='h-8 w-8' />
                    <h1>No Projects</h1>
                  </div>
                  <p>There are no assigned projects to display.</p>
                </div>
              )}
              {!fetchPartnerProposalsDashboard.isLoading && dashboardData?.project_location && (
                <div className='w-full grid grid-cols-6 h-screen/2'>
                  <div className='col-span-6 w-full border-l p-5'>
                    <MapGoogle projectList={dashboardData?.project_location} />
                  </div>
                </div>
              )}
            </Card>
          </div>
          <section className='grid md:grid-cols-1 xl:grid-cols-2 gap-4 lg:gap-8 my-4'>
            {dashboardData?.acquisition_types && (
              <BreakdownAcquisitionType title='Acquisition Types' breakdownAcquisition={dashboardData?.acquisition_types} />
            )}
            {dashboardData?.deal_types && <BreakdownDealType title='Deal Types' breakdownDeal={dashboardData?.deal_types} />}
            {dashboardData?.construction_types && (
              <BreakdownConstructionType title='Construction Type' breakdownConstruction={dashboardData?.construction_types} />
            )}
            {dashboardData?.social_designation && <SocialDesignationWidget data={dashboardData?.social_designation} />}
          </section>
          {/* <div className='my-4'>
            <ApplicationTimeline
              resourceType='PartnerProposal'
              title='Recent Activities'
            />
          </div> */}
        </div>
      )}
    </>
  );
};
export default Dashboard;
